import type { BrowserMetadata, BrowserMetadataService } from './types';

export class BrowserMetadataServiceImpl implements BrowserMetadataService {
  getMetadata(): BrowserMetadata {
    if (typeof window === 'undefined') {
      return {};
    }

    const timezone = (() => {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch {
        return undefined;
      }
    })();

    return {
      url: location.href,
      path: location.pathname,
      hostname: location.hostname,
      origin: location.origin,
      title: typeof document !== 'undefined' ? document.title : undefined,
      referrer: typeof document !== 'undefined' ? document.referrer : undefined,
      language: navigator.language,
      timezone,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      screenWidth: screen.width,
      screenHeight: screen.height,
      colorDepth: screen.colorDepth,
    };
  }
}
